import { c as _c } from "react/compiler-runtime";
import { useEngine } from '@svs/nova-poolbetting/core/frameworks/nextjs/engine';
import { getOutcomeCount } from '@svs/nova-poolbetting/core/lib/client';
import type { Outcome } from '@svs/nova-poolbetting/schema/coupon';
import type { EventNumber, EventType, SportType } from '@svs/nova-poolbetting/schema/sport';
import { convertOutcomeCountToLabels } from '@svs/nova-poolbetting/ui/Coupon';
import type { ReactNode } from 'react';
import { GameAnalysisOutcome } from './GameAnalysisOutcome';
type GameAnalysisOutcomeContainerProps = {
  eventAnalyses?: {
    eventOutcome: (Outcome | undefined)[];
    authorName: string;
  }[];
  sportType: SportType;
  eventType: EventType;
  authorName?: string;
  eventNumber: EventNumber;
};

/**
 * GameAnalysisOutcomeContainer component.
 *
 * @param root0 props
 * @param root0.sportType sport type to get outcome count for
 * @param root0.eventType event type to get outcome count for
 * @param root0.eventAnalyses event analyses containing outcomes and author name
 * @param root0.eventNumber event number for bet prediction
 * @returns Outcome container component
 */
export function GameAnalysisOutcomeContainer(t0) {
  const $ = _c(8);
  const {
    eventAnalyses,
    sportType,
    eventType,
    eventNumber
  } = t0;
  const definition = useEngine();
  if (!eventAnalyses) {
    return;
  }
  let t1;
  if ($[0] !== definition.model || $[1] !== eventType || $[2] !== sportType) {
    const outcomeCount = getOutcomeCount(sportType, eventType, definition.model);
    t1 = convertOutcomeCountToLabels(outcomeCount, undefined);
    $[0] = definition.model;
    $[1] = eventType;
    $[2] = sportType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const outcomeLabels = t1;
  let t2;
  if ($[4] !== eventAnalyses || $[5] !== eventNumber || $[6] !== outcomeLabels) {
    t2 = <GameAnalysisOutcome eventAnalyses={eventAnalyses} outcomeLabels={outcomeLabels} eventNumber={eventNumber} />;
    $[4] = eventAnalyses;
    $[5] = eventNumber;
    $[6] = outcomeLabels;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}